import { RequirementDefinitionTemplateForm } from "../../types";
import { CreateRequirementDefinitionBackgroundChecksPartialForm } from "../../../../../Requirements/modules/BackgroundChecks/types";
import { CreateBackgroundChecksPartialForm } from "../../../../modules/BackgroundChecks/createRequirementDefinition/CreateBackgroundChecksPartialForm";
import { WSPanel } from "@wingspanhq/fe-component-library";
import * as Yup from "yup";

type StandardBackgroundCheckValues = {
  package: string;
  instructions?: string;
};

export const STANDARD_BACKGROUND_CHECK_FORM: RequirementDefinitionTemplateForm<
  StandardBackgroundCheckValues,
  CreateRequirementDefinitionBackgroundChecksPartialForm
> = {
  getDefaultValues: template => ({
    instructions: "",
    package: ""
  }),
  mapFormData(values) {
    const data = {
      ...values,
      instructions: values.instructions || ""
    };

    return data;
  },
  partialForm: (
    <WSPanel>
      <CreateBackgroundChecksPartialForm />
    </WSPanel>
  ),
  validationSchema: Yup.object().shape({
    package: Yup.string().required("Required"),
    instructions: Yup.string()
  })
};
